<div class="assignment-detail">
  <div class="f-1">
    <div class="row first-row">
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.ASSIGNMENTNO' | translate }}:</div>
        <div class="dx-field-value">{{ data()?.AssignmentNo ?? 'N/A' }}</div>
      </div>
    </div>

    <div class="row">
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SUBTABLE.STATUS' | translate }}:</div>
        <div class="dx-field-value">{{ subtableData()?.StatusText ?? 'N/A' }}</div>
      </div>
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SUBTABLE.PRODNAME' | translate }}:</div>
        <div class="dx-field-value">{{ subtableData()?.ProdName ?? 'N/A' }}</div>
      </div>
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SACHBEARBEITER' | translate }}:</div>
        <div class="dx-field-value">{{ data()?.Sachbearbeiter ?? 'N/A' }} <span> </span></div>
      </div>
      @if (data()?.AdrPoints && data()!.AdrPoints! > 0) {
        <div class="dx-field-break f-1">
          <div class="dx-field-label">{{ 'ASSIGNMENT.ADRPOINTS' | translate }}:</div>
          <div class="dx-field-value">{{ data()!.AdrPoints }}</div>
        </div>
      }
    </div>

    <div class="row">
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SUBTABLE.DISPOVON' | translate }}:</div>
        <div class="dx-field-value">{{ subtableData()?.DispoVon | date }} <span></span></div>
      </div>
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SUBTABLE.DISPOBIS' | translate }}:</div>
        <div class="dx-field-value">{{ subtableData()?.DispoBis | date }} <span></span></div>
      </div>
      <div class="dx-field-break f-1">
        <div class="dx-field-label">{{ 'ASSIGNMENT.SUBTABLE.KONTAKT' | translate }}:</div>
        <div class="dx-field-value">{{ subtableData()?.Kontakt ?? 'N/A' }} <span></span></div>
      </div>
    </div>
  </div>
</div>
